export const ArrowRight = ({
  scale = 1,
  className,
}: {
  scale?: number;
  className?: string;
}) => {
  return (
    <svg
      width={16 * scale}
      height={16 * scale}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.1464 2.64649C8.34164 2.4512 8.65822 2.45116 8.85351 2.6464L13.8535 7.64517C13.9473 7.73892 14 7.86609 14 7.9987C14 8.13131 13.9474 8.25849 13.8536 8.35227L8.8536 13.3535C8.65836 13.5488 8.34178 13.5488 8.14649 13.3536C7.9512 13.1584 7.95116 12.8418 8.1464 12.6465L12.2928 8.49905L2.50012 8.5014C2.22398 8.50147 2.00007 8.27766 2 8.00152C1.99993 7.72538 2.22374 7.50147 2.49988 7.5014L12.293 7.49905L8.14649 3.3536C7.9512 3.15836 7.95116 2.84178 8.1464 2.64649Z"
        fill="black"
      />
    </svg>
  );
};
